import { Award, Loader } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Button } from '~/components/ui/button'
import { useSurveyBeforeCertificate } from '~/hooks/use-survey-before-certificate'
import SurveyDialog from '~/pages/scorm/components/survey/SurveyDialog'

/**
 * Bouton d'attestation, présent quand l'API la dit due (#10). Une formation
 * terminée en fait son action principale (#307) : c'est ce qui reste à y faire.
 * Le questionnaire de fin de parcours est proposé juste avant, jamais imposé (#320).
 */
function CertificateButton({ sessionId, primary }: { sessionId: string, primary?: boolean }) {
  const { t } = useTranslation()
  const { request, finish, pending, downloadingId } = useSurveyBeforeCertificate()

  return (
    <>
      <Button
        variant={primary ? 'default' : 'outline'}
        className="flex-1 basis-40"
        onClick={() => void request(sessionId)}
        disabled={downloadingId === sessionId}
      >
        {downloadingId === sessionId
          ? <Loader className="mr-2 size-4 animate-spin" />
          : <Award className="mr-2 size-4" />}
        {t('home.certificate.download')}
      </Button>
      {pending && <SurveyDialog sessionId={pending.sessionId} survey={pending.survey} onDone={() => void finish()} />}
    </>
  )
}

export default CertificateButton
